module.exports = {"pricing_image":{"href":"/img/機貨車價目表.jpg","target":"_blank"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/tw/setting/pricing/link.json
// module id = 741
// module chunks = 0 1 2 3 4 5